module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTI0IDRjLTcuNzMgMC0xNCA2LjI3LTE0IDE0IDAgMTAuNSAxNCAyNiAxNCAyNnMxNC0xNS41IDE0LTI2YzAtNy43My02LjI3LTE0LTE0LTE0em0wIDE5Yy0yLjc2IDAtNS0yLjI0LTUtNXMyLjI0LTUgNS01IDUgMi4yNCA1IDUtMi4yNCA1LTUgNXoiPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiIGZpbGw9Im5vbmUiPjwvcGF0aD4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/icon/content-address.svg
// module id = 31
// module chunks = 0